<template>
    <div class="Loader">
        <div v-bind:class="statusClassLoader">
            <div v-bind:class="statusClassCheckmark"></div>
        </div>
        <div v-if="status=='error'"><img src="@/assets/error-triangle.svg" class="error-triangle"></div>
    </div>
</template>

<script>
export default {
    name: 'Loader',
    props: ["status"],

    computed: {
        statusClassLoader(){
            if(this.status == "ok"){
                return "hidden";
            }else if(this.status == "loading"){
                return "circle-loader";
            }else if(this.status == "done"){
                return "circle-loader load-complete";
            }else{
                return "hidden";
            }
        },

        statusClassCheckmark(){
            if(this.status == "ok"){
                return "hidden";
            }else if(this.status == "loading"){
                return "hidden";
            }else if(this.status == "done"){
                return "checkmark draw";
            }else{
                return "hidden";
            }
        }
    }
}
</script>


<style scoped lang="scss">

.hidden{
    visibility: hidden;
}

.error-triangle{
    width: 30px;
}

$brand-success: #5cb85c;
$loader-size: 2em;
$check-height: $loader-size/2.2;
$check-width: $check-height/2;
$check-left: ($loader-size/15 + $loader-size/12);
$check-thickness: 5px;
$check-color: $brand-success;

.circle-loader {
    margin-right: 15px;
    border: 5px solid rgba(0, 0, 0, 0.2);
    border-left-color: $check-color;
    animation: loader-spin 1.2s infinite linear;
    position: relative;
    display: inline-block;
    vertical-align: top;
    border-radius: 50%;
    width: $loader-size;
    height: $loader-size;
}

.load-complete {
    -webkit-animation: none;
    animation: none;
    border-color: $check-color;
    transition: border 500ms ease-out;
}

.checkmark {
    /*display: none;*/

    &.draw:after {
        animation-duration: 800ms;
        animation-timing-function: ease;
        animation-name: checkmark;
        transform: scaleX(-1) rotate(135deg);
    }

    &:after {
        opacity: 1;
        height: $check-height;
        width: $check-width;
        transform-origin: left top;
        border-right: $check-thickness solid $check-color;
        border-top: $check-thickness solid $check-color;
        content: '';
        left: $check-left;
        top: $check-height;
        position: absolute;
    }
}

@keyframes loader-spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

@keyframes checkmark {
    0% {
        height: 0;
        width: 0;
        opacity: 1;
    }
    20% {
        height: 0;
        width: $check-width;
        opacity: 1;
    }
    40% {
        height: $check-height;
        width: $check-width;
        opacity: 1;
    }
    100% {
        height: $check-height;
        width: $check-width;
        opacity: 1;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Loader.vue